import React, { useState } from "react";
import { CheckCircle2, X } from "lucide-react";
import GitchaExplainerSheet from "@/components/GitchaExplainerSheet";
import "./PostedBanner.scss";

const PostedBanner = ({
  networkName,
  isBls,
  isSyndicated,
  isSyndicating,
  onShare,
  onSyndicate,
  showPro,
  onTryPro,
  onClose,
}) => {
  const [explainerOpen, setExplainerOpen] = useState(false);
  const audience = isBls ? `Every ${networkName} member can see it now` : "It's live on Gitcha.com and your Gitcha bio";
  return (
    <section className="posted-banner" aria-labelledby="posted-banner-title">
      <span className="posted-banner__icon" aria-hidden="true">
        <CheckCircle2 size={22} />
      </span>
      <div className="posted-banner__body">
        <h2 id="posted-banner-title" className="posted-banner__title">
          Your Buyer Want&#8209;Listing is live
        </h2>
        <p className="posted-banner__text">
          {audience}, and we'll tell you when a listing agent has a home that&nbsp;matches.
          {isBls && isSyndicated ? " It's also on Gitcha.com and your Gitcha bio, where home shoppers can find\u00a0you." : null}
          {isBls && !isSyndicated ? " Syndicate it to Gitcha.com to reach home shoppers there\u00a0too." : null}
        </p>
        {showPro && isSyndicated ? (
          <p className="posted-banner__pro">
            With Gitcha Pro, shoppers who find it can send you their name, timing and what they&nbsp;need.{" "}
            <button type="button" className="posted-banner__link" onClick={onTryPro}>
              Try Gitcha&nbsp;Pro
            </button>
          </p>
        ) : null}
        <div className="posted-banner__actions">
          <button type="button" className="btn btn-primary posted-banner__btn" onClick={onShare}>
            Share it
          </button>
          {isBls && !isSyndicated ? (
            <button
              type="button"
              className="btn posted-banner__btn posted-banner__btn--quiet"
              onClick={onSyndicate}
              disabled={isSyndicating}
            >
              {isSyndicating ? "Syndicating..." : "Syndicate to Gitcha.com"}
            </button>
          ) : null}
          <button type="button" className="posted-banner__link" onClick={() => setExplainerOpen(true)}>
            What is Gitcha.com?
          </button>
        </div>
      </div>
      <button type="button" className="posted-banner__close" aria-label="Close" onClick={onClose}>
        <X size={18} aria-hidden="true" />
      </button>
      <GitchaExplainerSheet
        show={explainerOpen}
        onHide={() => setExplainerOpen(false)}
        networkName={networkName}
        surface="posted_banner"
      />
    </section>
  );
};

export default PostedBanner;
